<ion-header>
  <ion-toolbar>

    <ion-button style="font-size: 11px;" slot="end" class="back" fill="solid" (click)="cancel()">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{'General.Cancel' | translate }}
    </ion-button>

    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

@if (isRetailItem) {
  <ion-content (click)="track($event)">
    <div class="image-container" #imageContainer>
      <!-- Take off name if mobile
      <div class="media-header media-view">
        <span class="collection">{{'Order.Category' | translate}}</span>
        <h1 class="title-retail">{{item.item.itemName.translations[translateService.currentLang]}}</h1>
      </div>-->
      <!-- ImagesforeveryColor -->
      <div class="item-image-container2" >
        @if (selectedColorImage.otherImages.length>0) {
          <div class="small-images" >
            @for (img of selectedColorImage.otherImages; track img; let i = $index) {
              <div class="image-parent style" >
                <img class="img2" [class.style2]="i==0" #img2 [id]="i" (click)="changeImage(img, $event)" [src]="getColorImages(img)" >
              </div>
            }
          </div>
        }
        <!--
        <div *ngIf="!selectedImage" class="item-image" id="itemImage" [style.background-image]="getItemImage(item.item)"></div>
        <div *ngIf="selectedColorImage.otherImages.length>0 && selectedImage" (click)="zoom()" class="item-image"  [style.background-image]="selectedImage"></div>
        -->
        @if (selectedColorImage.otherImages.length>0 && selectedImage) {
          <div (click)="zoom()" class="item-image">
            <ion-content class="ion-padding" scroll-y="false">
              <!--
              <ion-slides (ionSlideDidChange)="onSlideChange()" #slider>
                <ion-slide *ngFor="let img of selectedColorImage.otherImages;let i=index">
                  <div class="slide">
                    <img [src]="getColorImages(img)" >
                  </div>
                </ion-slide>
              </ion-slides>
              -->
              <!--
              <swiper
                #swiper
                (slideChange)="onSlideChange()"
                [slidesPerView]="1"
                [spaceBetween]="10"
                >
                <ng-template swiperSlide *ngFor="let img of selectedColorImage.otherImages; let i = index">
                  <div class="slide">
                    <img [src]="getColorImages(img)">
                  </div>
                </ng-template>
              </swiper>
              -->
              <swiper-container
                #swiper
                slides-per-view="1"
                space-between="10"
                (slidechange)="onSlideChange()"
                >
                @for (img of selectedColorImage.otherImages; track img; let i = $index) {
                  <swiper-slide>
                    <div class="slide">
                      <img [src]="getColorImages(img)" />
                    </div>
                  </swiper-slide>
                }
              </swiper-container>
            </ion-content>
          </div>
        }
      </div>
      <div class="additional-info">
        <div class="header full-view">
          <span class="collection">{{'Order.Category' | translate}}</span>
          <h1 class="title-retail">{{item.item.itemName.translations[translationService.getLanguage()]}}</h1>
          @if (!combinationPrice) {
            <span class="price">{{item.item.price | currency:'USD':'symbol':'1.2-2'}}</span><br>
          }
          @if (combinationPrice) {
            <span class="price" >{{combinationPrice | currency:'USD':'symbol':'1.2-2'}}</span>
          }
          @if (itemQuantity>0) {
            <span style="font-size: 11px; color: gray; font-weight: bold; margin-left: 0.25rem;">({{itemQuantity}} {{'Menu.InStock' | translate}} )</span>
          }
          @if (itemQuantity<=0 && item.item.isInventoryExist && item.item.isInventoryActive && isCombination) {
            <span style="font-size: 11px; color: gray; font-weight: bold; margin-left: 0.25rem;">{{'Menu.OutOfStockTitle' | translate}}</span>
          }
        </div>
        <hr class="line full-view">
        <div class="additional-details">
          <h4 class="mobileOnly">{{item.item.itemName.translations[translationService.getLanguage()]}}</h4>
          <div class="show">
            @if (!selectedColor) {
              <span class="collection selectedColor">{{'Order.Colors' | translate}}</span>
            }
            @if (selectedColor) {
              <span class="collection selectedColor" >{{selectedColor}}</span>
            }
          </div>
          <div class="colors">
            @for (color of item.item.itemColors; track color; let i = $index) {
              @if (!color.isDeleted) {
                <div class="colorCircle" #colorCircle (click)="changeColor(color.name,color, $event)" [id]="color.id">
                  @if (color.colorImage != null && color.colorImage !='' ) {
                    <div class="color colorImage" [id]="color.id"  [style.background-image]="getColorImage(color)" ></div>
                  }
                  @if (color.code && (color.colorImage == null || color.colorImage =='')) {
                    <div class="color" [id]="color.id" [style.background]="color.code"  ></div>
                  }
                  @if (!color.code && (color.colorImage == null || color.colorImage =='')) {
                    <div class="color" [id]="color.id" alt=""></div>
                  }
                </div>
              }
            }
          </div>
          <div class="price-quantity media-view">
            @if (!combinationPrice) {
              <span class="price">{{item.item.price | currency:'USD':'symbol':'1.2-2'}} CAD</span><br>
            }
            @if (combinationPrice) {
              <span class="price" >{{combinationPrice | currency:'USD':'symbol':'1.2-2'}} CAD</span>
            }
            @if (itemQuantity>0) {
              <span style="font-size: 11px; color: gray; font-weight: bold;">({{itemQuantity}} {{'Menu.InStock' | translate}} )</span>
            }
            @if (itemQuantity<=0 && item.item.isInventoryExist && item.item.isInventoryActive && isCombination) {
              <span style="font-size: 11px; color: gray; font-weight: bold;">{{'Menu.OutOfStockTitle' | translate}}</span>
            }
          </div>
          <hr class="line media-view">
          <div class="size">
            <div class="size-lbl">{{'Order.Size' | translate}}</div>
            <div class="different-sizes">
              @for (s of item.item.itemSizes; track s; let i = $index) {
                @if (!s.isDeleted) {
                  <div class="sizes" #sizes [id]="s.id"  (click)="selectSize(s.abbreviation, $event)">
                    <label [id]="s.id">{{s.abbreviation.translations[translationService.getLanguage()]}}</label>
                  </div>
                }
              }
            </div>
          </div>
          @if (brands.length>0) {
            <div class="brand">
              <div class="btns">
                <button class="btn">{{brands[0].name.translations[translationService.getLanguage()]}}</button>
              </div>
            </div>
          }
          <div class="error" [hidden]="!postError">
            <ion-text color="danger">
              <h6 class="error-message">{{'Order.PleaseSelectSize' | translate}}</h6>
            </ion-text>
          </div>
          <div class="add-cart">
            <div class="qty">
              <mat-form-field  class="quantity">
                <mat-label>Qty</mat-label>
                <select (change)="quantityChange($event)" [(ngModel)]="selectedQuantity" matNativeControl required>
                  @for (qty of quantity; track qty) {
                    <option [value]="qty">{{qty}}</option>
                  }
                </select>
              </mat-form-field>
            </div>
            <!--
            <div class="carts">
              <ng-container *ngIf="!orderType">
                <button class="cart"  (click)="onStartOrder('pickup')" *ngIf="(item.item.isTakeOut  && (orderType=='pickup' || !orderType))">{{'Order.AddCartPickup' | translate}}</button>
                <button class="cart"  (click)="onStartOrder('delivery')" *ngIf="(item.item.isDelivery && (orderType=='delivery' || !orderType))">{{'Order.AddCartDelivery' | translate}}</button>
                <button class="cart"  (click)="onStartOrder('shipping')" *ngIf="(item.item.isShipping && (orderType=='shipping'|| !orderType)) ">{{'Order.AddCartShipping' | translate}}</button>
              </ng-container>
              <ng-container *ngIf="orderType">
                <button class="cart"  (click)="onStartOrder()" *ngIf="(item.item.isTakeOut  && (orderType=='pickup' || !orderType))">{{'Order.AddCartPickup' | translate}}</button>
                <button class="cart"  (click)="onStartOrder()" *ngIf="(item.item.isDelivery && (orderType=='delivery' || !orderType))">{{'Order.AddCartDelivery' | translate}}</button>
                <button class="cart"  (click)="onStartOrder()" *ngIf="(item.item.isShipping && (orderType=='shipping'|| !orderType)) ">{{'Order.AddCartShipping' | translate}}</button>
              </ng-container>
            </div>
            -->
            <div class="carts">
              @if ((item.item.isTakeOut && store.allowPickup)) {
                <button class="cart"  (click)="onStartOrder('pickup')">{{'Order.AddCartPickup' | translate}}</button>
              }
              @if ((item.item.isDelivery && store.allowDelivery)) {
                <button class="cart"  (click)="onStartOrder('delivery')">{{'Order.AddCartDelivery' | translate}}</button>
              }
              @if ((item.item.isShipping && store.allowShipping) ) {
                <button class="cart"  (click)="onStartOrder('shipping')">{{'Order.AddCartShipping' | translate}}</button>
              }
            </div>
          </div>
          <div class="description">
            @if (item.item.itemDescription) {
              <div class="short-description">
                <button class="accordion" (click)="openAccordion($event)">{{item.item.itemDescription.title.translations[translationService.getLanguage()]}}</button>
                <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.item.itemDescription.description.translations[translationService.getLanguage()])">
                </div>
              </div>
            }
            @if (item.item.descriptionExtended) {
              <div class="Long-description">
                <button class="accordion" (click)="openAccordion($event)">{{item.item.descriptionExtended.title.translations[translationService.getLanguage()]}}</button>
                <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.item.descriptionExtended.description.translations[translationService.getLanguage()])">
                </div>
              </div>
            }
            @if (settingService.configuration.shippingReturnPolicy) {
              <div class="shipping-return">
                <button class="accordion" (click)="openAccordion($event)">{{settingService.configuration.shippingReturnPolicy.title.translations[translationService.getLanguage()]}}</button>
                <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(settingService.configuration.shippingReturnPolicy.description.translations[translationService.getLanguage()])">
                </div>
              </div>
            }
            <!--<ng-container *ngIf="settingService.configuration.freeShipping">
            <div class="shipping-details" *ngIf="settingService.configuration.freeShipping.allowed">
              <a href="" style="color: blue;">{{'Order.FreeShipping' | translate }} ${{settingService.configuration.freeShipping.price}}</a>
            </div>
          </ng-container>-->
        </div>
        <!--
        <div class="rules" >
          <div>
            <a class="rules-link" (click)="openTab()" style="color: blue; font-size: 11px;">{{'Order.ShippingRules' | translate}}</a>
          </div>
          <div>
            <a class="rules-link" (click)="openTab()" style="color: blue; font-size: 11px;">{{'Order.ReturnPolicy' | translate}}</a>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
  @if (newOrder) {
    <div  class="modal-new-cart">
      <div class="container-warning">
        <div class="new-order">{{'Confirmation.NewOrder' | translate}}</div>
        <p class="para">{{'Confirmation.Warning' | translate}}</p>
        <div class="buttons">
          <button (click)="emptyCart()" class="btns"  style="margin-right: 10px;">{{'General.Yes' | translate}}</button>
          <button class="btns" id="no">{{'General.No' | translate}}</button>
        </div>
      </div>
    </div>
  }
  @if (selectedColorImage.otherImages.length>0) {
    <div #zoomIn class="zoom-in hide">
      <div class="zoom-container">
        @for (img of selectedColorImage.otherImages; track img) {
          <div class="small">
            <div [style.background-image]="zoomSmallImages(img)" ></div>
          </div>
        }
        <ion-icon (click)="close()" style="cursor: pointer;" name="close" class="close"></ion-icon>
        @for (img of selectedColorImage.otherImages; track img) {
          <img class="merchant-image" [src]="getColorImages(img)"  >
        }
      </div>
    </div>
  }
</ion-content>
}

<!-- Logic for food -->
@if (!isRetailItem) {
  <ion-content  (click)="track($event)">
    <div class="item-image-container"
    style="height: 300px; width: 80%; margin-left: auto; margin-right: auto; margin-top: 15px; text-align: center; 
    background-size: cover; background-repeat: no-repeat; background-position: center center; border-radius: 4px;" [style.background-image]="getItemImage(item.item)"> 
      <!-- <img *ngIf="item.item._itemImage" style="max-width:300px;" [src]="item.item._itemImage">
      <img *ngIf="!item.item._itemImage" src="assets/imgs/menu/not-found.png"> -->
    </div>
    <div style="width: 80%; margin-left: auto; margin-right: auto; text-align: center;">
      @if (item) {
        <ion-note style="text-align: center;">
          <div style="font-size: 20px; margin-top: 12px; margin-bottom: 8px;">
            <b>{{ item.item.itemName.translations[translationService.getLanguage()] }}</b><br>
            @if (itemQuantity > 0  &&  item.item.isInventoryExist  && item.item.isInventoryActive) {
              <b>({{ itemQuantity }} {{ 'Menu.InStock' | translate }} )</b>
            }
            <!-- <b *ngIf="itemQuantity<=0 &&  item.item.isInventoryExist  && item.item.isInventoryActive && isCombination">({{'Menu.OutOfStockTitle' | translate}})</b> -->
          </div>
          <!--@if(item.subItems && item.subItems.length > 0){
            <div style="display: flex; margin-bottom: 8px; justify-content: center;">
              @for (subItem of item.subItems; track subItem) {
                @if(subItem.subItemAskBefore){
                  <ion-col style="display: flex; max-width: fit-content;">
                    <ion-card  class="ion-activatable">
                      <ion-ripple-effect></ion-ripple-effect>
                      <ion-grid style="padding: 8px; color: white; background-color: #333;" (click)="subItemClicked(subItem)">
                        <ion-row>
                          @if(subItem.nameOverwrite && subItem.nameOverwrite.translations[translationService.getLanguage()]){
                            <span style="font-size: 18px;">{{ subItem.nameOverwrite.translations[translationService.getLanguage()] }}</span>
                          }
                          @if(!subItem.nameOverwrite || !subItem.nameOverwrite.translations[translationService.getLanguage()]){
                            <span style="font-size: 18px;">{{ subItem.itemName.translations[translationService.getLanguage()] }}</span>
                          }
                        </ion-row> 
                      </ion-grid>
                    </ion-card>
                  </ion-col>
                }
              }
            </div>
          }-->
          <div style="text-align: center;">
            @if (orderType) {
              <!--@if (item.isPermitQuantities) {
                <div class="Quantity-Box">
                  <div class="Item-number-Container">
                    <button (click)="changeItemNumber(-1)" class="Unstyled-Button">-</button>
                    <p>{{selectedQuantity}}</p>
                    <button (click)="changeItemNumber(1)" class="Unstyled-Button">+</button>
                  </div>
                </div>
              }-->
              <ion-button  [class.disable]=" orderType == 'shipping' && isFoodItem == false " id="add-to-cart" (click)="onStartOrder()">
                {{'Menu.AddToOrder' | translate}}
                <ion-icon slot="end" name="add-outline"></ion-icon>
              </ion-button>
            }
            @if (!orderType) {
              <!--@if (item.isPermitQuantities) {
                <div class="Quantity-Box">
                  <div class="Item-number-Container">
                    <button (click)="changeItemNumber(-1)" class="Unstyled-Button">-</button>
                    <p>{{selectedQuantity}}</p>
                    <button (click)="changeItemNumber(1)" class="Unstyled-Button">+</button>
                  </div>
                </div>
              }-->
              <ion-button id="add-to-cart" (click)="onStartOrder('pickup')">
                {{'Order.AddCartPickup' | translate}}
                <ion-icon slot="end" name="add-outline"></ion-icon>
              </ion-button>
              <ion-button  id="add-to-cart" (click)="onStartOrder('delivery')">
                {{'Order.AddCartDelivery' | translate}}
                <ion-icon slot="end" name="add-outline"></ion-icon>
              </ion-button>
            }
          </div>
          <!--@if(item.subItems && item.subItems.length > 0){
            <div style="display: flex; justify-content: center;">
              @for (subItem of item.subItems; track subItem) {
                @if(!subItem.subItemAskBefore){
                  <ion-col style="display: flex; max-width: fit-content;">
                    <ion-card  class="ion-activatable">
                      <ion-ripple-effect></ion-ripple-effect>
                      <ion-grid style="padding: 8px; color: white; background-color: #333;" (click)="subItemClicked(subItem)">
                        <ion-row>
                          @if(subItem.nameOverwrite && subItem.nameOverwrite.translations[translationService.getLanguage()]){
                            <span style="font-size: 18px;">{{ subItem.nameOverwrite.translations[translationService.getLanguage()] }}</span>
                          }
                          @if(!subItem.nameOverwrite || !subItem.nameOverwrite.translations[translationService.getLanguage()]){
                            <span style="font-size: 18px;">{{ subItem.itemName.translations[translationService.getLanguage()] }}</span>
                          }
                        </ion-row> 
                      </ion-grid>
                    </ion-card>
                  </ion-col>
                }
              }
            </div>
          }-->
          @if (item.item.description) {
            <div style="font-size: 16px; margin-top: 12px;" [innerHTML]="item.item.description.translations[translationService.getLanguage()]">
            </div>
          }
        </ion-note>
      }
    </div>
    @if (isAlcohol) {
      <div  class="modal-new-cart">
        <div class="container-warning">
          <div class="new-order" style="font-size: 22px;">{{'Confirmation.AlcoholItemNotice' | translate}}</div>
          <p class="para">{{'Confirmation.AlcoholItemNoticeText' | translate}}</p>
          <div class="buttons" style="justify-content: flex-end;">
            <button (click)="onStartOrder(selectedOrderType)" class="btns" style="margin-right: 20px; margin-top: 0;">OK</button>
          </div>
        </div>
      </div>
    }
    @if (newOrder) {
      <div  class="modal-new-cart">
        <div class="container-warning">
          <div class="new-order">{{'Confirmation.NewOrder' | translate}}</div>
          <p class="para">{{'Confirmation.Warning' | translate}}</p>
          <div class="buttons">
            <button (click)="emptyCart()" class="btns" style="margin-right: 10px;">{{'General.Yes' | translate}}</button>
            <button class="btns" id="no">{{'General.No' | translate}}</button>
          </div>
        </div>
      </div>
    }
  </ion-content>
}